export function CaretDownIcon(props: React.SVGProps<SVGSVGElement>) {
    return (
        <svg width="15" viewBox="0 0 15 9" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M14.3943 0.341538C14.0449 -0.00777915 13.4786 -0.00777917 13.1293 0.341538L7.5004 5.97041L1.87152 0.341538C1.52221 -0.0077797 0.955853 -0.00777972 0.606536 0.341538C0.257219 0.690854 0.257219 1.25721 0.606536 1.60652L6.86791 7.86789C7.21722 8.21721 7.78358 8.21721 8.13289 7.86789L14.3943 1.60653C14.7436 1.25721 14.7436 0.690855 14.3943 0.341538Z"
                fill="currentColor"
            />
        </svg>
    );
}
